import styled from 'styled-components';
import { ACCENT, ACCENT_HOVER, WHITE, PRIMARY, PRIMARY_EXTRA_LIGHT, HOVER_ITEM_COLOR, PRIMARY_DISABLED } from '../../utils/colors';

export const Title = styled.h2`
  font-family: 'FigtreeBold', sans-serif;
  font-size: 28px;
  margin-bottom: 20px;
`

export const EmptyQuotationText = styled.p`
  font-family: 'Figtree', sans-serif;
  font-size: 16px;
`

export const QuotationCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  margin-bottom: 2rem;
  border: 1px solid ${PRIMARY_EXTRA_LIGHT};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  object-fit: cover;
  /* max-width: 20rem; */
`

export const QuotationCardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 4px;
  padding: 1rem;
  @media (max-width: 525px) {
    padding: 0 1rem;
  }

  @media (max-width: 410px) {
    padding: 0 0.5rem;
  }
`;

export const ProductImage = styled.img`
  width: 100%;
  max-width: 250px;
  height: auto;

  @media (max-width: 525px) {
    max-width: 150px;
  }

  @media (max-width: 410px) {
    max-width: 100px;
  }
`;

export const ProductName = styled.h3`
  font-family: 'FigtreeBold', sans-serif;
  font-size: 1rem;
  margin: 0;

  @media (max-width: 800px) {
    font-size: 0.8rem;
  }
`

export const ProductCategory = styled.h4`
  font-family: 'FigtreeLight', sans-serif;
  font-size: 14px;
  margin: 0;

   @media (max-width: 800px) {
    font-size: 0.7rem;
  }
`

export const RemoveButton = styled.button`
  background-color: ${ACCENT};
  color: ${WHITE};
  border: none;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    background-color: ${ACCENT_HOVER};
  }
`;

export const RequestQuotationButton = styled.button`
  background-color: ${PRIMARY};
  color: ${WHITE};
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 1rem;
  font-family: 'FigtreeBold', sans-serif;

  &:hover {
    background-color: ${HOVER_ITEM_COLOR};
  }

  &:disabled {
    background-color: ${PRIMARY_DISABLED};
    cursor: not-allowed;
  }
`

export const ProductButtons = styled.div`
  display: flex;
  justify-content: center; 
  align-items: center;
  gap: 8px;

  @media (max-width: 350px) {
    flex-wrap: wrap;
  }
`;